import { Controller, useFormContext } from 'react-hook-form'
import { CurecallInput, CurecallInputLabel } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { PlanningTabFormValues } from './../planning.type'
import { useId } from 'react'

export default function PlanningTabRangeOfDaysFields() {
  const { t } = useTranslation()
  const id = useId()
  const {
    formState: { errors },
    watch,
    setValue,
    control,
  } = useFormContext<PlanningTabFormValues>()

  const handleChangeRangeOfDaysStart = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.valueAsNumber
    if (typeof newValue === 'number' && !Number.isNaN(newValue)) {
      setValue('relativeRangeOfDays', [newValue, watch('relativeRangeOfDays')[1]])
    }
  }

  const handleChangeRangeOfDaysEnd = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.valueAsNumber
    if (typeof newValue === 'number' && !Number.isNaN(newValue)) {
      setValue('relativeRangeOfDays', [watch('relativeRangeOfDays')[0], newValue])
    }
  }

  return (
    <Controller
      control={control}
      name="relativeRangeOfDays"
      rules={{ required: true }}
      render={() => (
        <fieldset id={id}>
          <CurecallInputLabel
            htmlFor={id}
            label={t('pages.planning.form.relative-range-of-days-label')}
            isRequired={true}
          />
          <div className="c-flex c-items-start c-gap-2">
            <CurecallInput
              label={t('pages.planning.form.relative-range-of-days-from')}
              onChange={handleChangeRangeOfDaysStart}
              value={watch('relativeRangeOfDays')[0]}
              max={0}
              type="number"
              errorMessage={errors['relativeRangeOfDays'] && ' '}
              labelAndInputClassName="c-flex c-items-center"
              labelClassName="tw-mb-0 tw-w-min"
              inputClassName="tw-w-20"
            />

            <CurecallInput
              label={t('pages.planning.form.relative-range-of-days-to')}
              onChange={handleChangeRangeOfDaysEnd}
              value={watch('relativeRangeOfDays')[1]}
              min={0}
              type="number"
              errorMessage={errors['relativeRangeOfDays'] && ' '}
              labelAndInputClassName="c-flex c-items-center"
              labelClassName="tw-mb-0 tw-w-min"
              inputClassName="tw-w-20"
            />
          </div>
        </fieldset>
      )}
    />
  )
}
